import { Reveal } from "./Reveal";

const ASSETS = [
  {
    id: "hospitality",
    name: "Hospitality & Hotels",
    image:
      "https://images.unsplash.com/photo-1683290844875-0eee4089069a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBob3RlbCUyMGZhY2FkZXxlbnwwfHx8fDE3OTE4MzM2ODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Monumental heritage luxury hotel palace facade with ornate stonework",
    description:
      "Major hotels, significant operational hospitality assets and established hotel portfolios.",
  },
  {
    id: "commercial-portfolios",
    name: "Commercial Real Estate & Portfolios",
    image:
      "https://images.unsplash.com/photo-1549483249-f0b359d1e289?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwb2ZmaWNlJTIwdG93ZXIlMjBsb25kb24lMjBza3lsaW5lJTIwZXZlbmluZ3xlbnwwfHx8fDE3OTE4MzI0MTB8MA&ixlib=rb-4.1.0&q=85",
    alt: "London skyline with landmark commercial towers",
    description:
      "Landmark commercial buildings, major property portfolios and strategic ownership situations.",
  },
  {
    id: "aviation-infrastructure",
    name: "Aviation & Infrastructure",
    image:
      "https://images.unsplash.com/photo-1694160027547-b0696cf1ad45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxhaXJwbGFuZSUyMGVuZ2luZSUyMHR1cmJpbmUlMjBnZW9tZXRyeXxlbnwwfHx8fDE3OTE5MTk3Njl8MA&ixlib=rb-4.1.0&q=85",
    alt: "Sculptural aircraft turbine engine geometry in monochrome",
    description:
      "Aviation businesses, infrastructure assets and complex, capital-intensive situations.",
  },
];

const Corners = () => (
  <>
    <span className="absolute top-4 left-4 w-6 h-6 border-t border-l border-[#F6F4F0]/80" aria-hidden="true" />
    <span className="absolute top-4 right-4 w-6 h-6 border-t border-r border-[#F6F4F0]/80" aria-hidden="true" />
    <span className="absolute bottom-4 left-4 w-6 h-6 border-b border-l border-[#F6F4F0]/80" aria-hidden="true" />
    <span className="absolute bottom-4 right-4 w-6 h-6 border-b border-r border-[#F6F4F0]/80" aria-hidden="true" />
  </>
);

export const SectorFocus = () => (
  <div className="grid md:grid-cols-3 gap-8 lg:gap-10" data-testid="real-assets-grid">
    {ASSETS.map((s, i) => (
      <Reveal key={s.id} delay={i * 0.1}>
        <article data-testid={`real-asset-card-${s.id}`} className="group relative h-full">
          <div className="relative aspect-[4/5] overflow-hidden border border-[#E3E0D8]">
            <img
              src={s.image}
              alt={s.alt}
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover grayscale contrast-110 brightness-[0.95] transition-[filter,transform] duration-700 ease-out group-hover:brightness-100 group-hover:scale-105"
            />
            <Corners />
            <span className="absolute top-7 left-1/2 -translate-x-1/2 font-serif text-sm tracking-[0.3em] text-[#F6F4F0]/80">
              0{i + 1}
            </span>
          </div>
          <div className="relative px-2 pt-7">
            <h3 className="font-serif text-2xl lg:text-3xl font-light tracking-tight text-[#1F1E1B] transition-colors duration-500">
              {s.name}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-[#6E6A61]">{s.description}</p>
            <span className="mt-5 block h-px w-full bg-[#E3E0D8] relative overflow-hidden">
              <span className="absolute inset-0 bg-[#1F1E1B]/60 -translate-x-full group-hover:translate-x-0 transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)]" />
            </span>
          </div>
        </article>
      </Reveal>
    ))}
  </div>
);
